import type { SVGProps } from 'react';

const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20 3.015c-.55 0-1 .45-1 1v2.27l-.64-.64A8.94 8.94 0 0 0 12 3.005c-2.4 0-4.66.95-6.36 2.65A8.94 8.94 0 0 0 3 12.015c0 2.4.94 4.66 2.64 6.36s3.96 2.64 6.36 2.64 4.66-.94 6.36-2.64c.85-.85 1.52-1.85 1.97-2.96a.998.998 0 1 0-1.85-.75c-.35.86-.87 1.64-1.53 2.3a6.96 6.96 0 0 1-4.95 2.05 6.96 6.96 0 0 1-4.95-2.05A6.96 6.96 0 0 1 5 12.015c0-1.87.73-3.63 2.05-4.95A6.96 6.96 0 0 1 12 5.015c1.87 0 3.63.73 4.95 2.05l.95.95H15c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1"
    />
  </svg>
);
export default SvgRefresh;
